<template>
<div class="chapter">
<div class="inner_page">
<h1 title="Dedication"> </h1>
<p class="sectiontop" style="text-align: center;">For my father, Mort Reznick, a golf lover and a great guy.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?c51b6f38